module.exports = __webpack_public_path__ + "media/dashboard/assets/images/phone-c05abb15a5fb56214b74a6d848c189c9.svg";